import { useQuery } from "@tanstack/react-query";
import {
	getAccountSummaryByClose,
	getCloseDates,
	getCostCenters,
} from "../repositories/SummaryByCloseDateRepository";

const NO_POLLING = {
	refetchOnWindowFocus: false,
	refetchOnReconnect: false,
} as const;

export const useCostCenters = () =>
	useQuery({
		queryKey: ["summaryByCloseDateCostCenters"],
		queryFn: ({ signal }) => getCostCenters(signal),
		staleTime: Number.POSITIVE_INFINITY,
		...NO_POLLING,
	});

export const useCloseDates = (costCenterId: number | null) =>
	useQuery({
		queryKey: ["summaryByCloseDateCloseDates", costCenterId],
		queryFn: ({ signal }) => getCloseDates(costCenterId as number, signal),
		enabled: costCenterId != null,
		staleTime: Number.POSITIVE_INFINITY,
		...NO_POLLING,
	});

export const useAccountSummary = (
	costCenterId: number | null,
	closeDate: string | null,
) =>
	useQuery({
		queryKey: ["summaryByCloseDate", costCenterId, closeDate],
		queryFn: ({ signal }) =>
			getAccountSummaryByClose(
				costCenterId as number,
				closeDate as string,
				signal,
			),
		enabled: costCenterId != null && !!closeDate,
		...NO_POLLING,
	});
